import React from 'react';
import PropTypes from 'prop-types';
import AvatarWithTitle, { Title } from '@scoir/avatar-with-title';
import CollegeCrest from '@scoir/college-crest';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var useStyles = makeStyles(function (theme) {
  return {
    crestLink: {
      textDecoration: 'none'
    },
    nameLink: {
      color: theme.palette.text.primary
    }
  };
});

var Heading = function Heading(_ref) {
  var _ref$AvatarWithTitleP = _ref.AvatarWithTitleProps,
      AvatarWithTitleProps = _ref$AvatarWithTitleP === void 0 ? {} : _ref$AvatarWithTitleP,
      _ref$CollegeCrestProp = _ref.CollegeCrestProps,
      CollegeCrestProps = _ref$CollegeCrestProp === void 0 ? {} : _ref$CollegeCrestProp,
      to = _ref.to,
      scid = _ref.scid,
      name = _ref.name,
      children = _ref.children;
  var classes = useStyles();
  return /*#__PURE__*/React.createElement(AvatarWithTitle, _extends({}, AvatarWithTitleProps, {
    avatar: /*#__PURE__*/React.createElement(Link, {
      className: classes.crestLink,
      to: to
    }, /*#__PURE__*/React.createElement(CollegeCrest, _extends({}, CollegeCrestProps, {
      scid: scid
    }))),
    title: /*#__PURE__*/React.createElement(Link, {
      to: to,
      className: classes.nameLink
    }, /*#__PURE__*/React.createElement(Title, null, name))
  }), children);
};

Heading.propTypes = {
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object]).isRequired,
  scid: CollegeCrest.propTypes.scid,
  children: PropTypes.any,
  name: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  AvatarWithTitleProps: PropTypes.object,
  CollegeCrestProps: PropTypes.object
};

export default Heading;
//# sourceMappingURL=index.module.js.map
